// Formats a CO2 figure for display.
//
// Unlike formatEuro, which coerces null to €0,00, this renders a dash for
// anything that is not a real number. "We could not calculate this" and "this
// saved nothing" are different claims, and the milieu-circulariteit standaard
// is explicit that a missing kengetal must not be read as zero.
//
// Formats manually rather than through Intl: the repo-local node used by some
// npm scripts is a small-icu build, where nl-NL silently falls back to an
// en-US separator and the output stops matching the rest of the UI.
//
// AI-CONTEXT: See docs/features/materials-co2-circulariteit.md

/**
 * @param {number|null|undefined} kg
 * @returns {string} e.g. '21,3 kg', '1,3 ton', or '—' when unknown
 */
const formatCo2 = (kg) => {
    if (kg === null || kg === undefined || kg === '') return '—'
    const value = Number(kg)
    if (!Number.isFinite(value)) return '—'

    if (Math.abs(value) >= 1000) {
        return `${(value / 1000).toFixed(1).replace('.', ',')} ton`
    }
    return `${value.toFixed(1).replace('.', ',')} kg`
}

export default formatCo2
